<template>
  <div class="form-styles">
    <h1>{{ this.Form['title'] }}</h1>
    <div v-html="this.Form['desc'] "></div>
    <form id="demo" method="post" enctype="multipart/form-data">
      <!-- text -->
      <div class="form">
        <div class="form-content">
          <div v-if="!form_submitted" class="form-row" v-for="form_field in formFields">
            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_TEXT">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <input
                type="text"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                :disabled="form_submitted"
              />
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <div v-if="form_field['fieldId'] == PHONE_NUMBER">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <input
                type="text"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                :disabled="form_submitted"
                v-numeric-plus-only
              />
              <!-- <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p> -->
              <p class="error" v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && (typeof $v.form_values[form_field['form_field_id']].$model === 'string' ? $v.form_values[form_field['form_field_id']].$model : $v.form_values[form_field['form_field_id']].$model.toString()).replace(/[+\-\s]/g, '').length < 7">
                Minimum of 7 characters required
              </p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_TEXT_MULTIPLE">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
                <span style="cursor: pointer; font-weight: 700; color: #005cb9; position: absolute; right: 0px;" v-on:click="addNewInputText(form_field['form_field_id'])">Add new {{ form_field['label'].toLowerCase() }}</span>
              </label>
              <div  v-for="(input_text_multiple_index, pos) in input_text_multiple_indexes[form_field['form_field_id']]" :key="pos">
                <input
                  type="text"
                  v-model.trim.lazy="input_text_multiple_items[form_field['form_field_id']][input_text_multiple_index]"
                  :disabled="form_submitted"
                />
              </div>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_EMAIL">
              <hr />
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>

              <input
                type="email"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                :disabled="form_submitted"
              />
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
              <p
                class="error"
                v-if="($v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].email) || validation_errors.hasOwnProperty([form_field['form_field_id']])"
              >{{ label_invalid }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_TEXTAREA">
              <hr />
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <textarea
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                :disabled="form_submitted"
                rows="3"
                maxlength="3000"
              ></textarea>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
              <p
                class="error"
                v-if="!$v.form_values[form_field['form_field_id']].maxLength"
              >{{ label_text_too_long}}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_SELECT">
              <hr />
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <div>
                <select
                  v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                  :disabled="form_submitted"
                >
                  <option value selected="selected">-- {{ label_select }} --</option>
                  <option
                    v-for="(value, index) in JSON.parse(form_field['value']) "
                    :value="value"
                    :key="value"
                  >{{ value }}</option>
                  <option value="other_select">-- {{ label_other }} --</option>
                </select>
                <p
                  class="error"
                  v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
                >{{ label_required }}</p>
              </div>
              <div v-if="otherSelected(form_field['form_field_id'])">
                <input
                  type="text"
                  :disabled="form_submitted"
                  v-model.trim.lazy="$v.form_values['others'][form_field['form_field_id']].$model"
                />
                <p
                  class="error"
                  v-if="form_field['required'] == 1 && $v.form_values['others'][form_field['form_field_id']].$dirty && !$v.form_values['others'][form_field['form_field_id']].required"
                >{{ label_required }}</p>
              </div>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == COUNTRY_WIZARD">
              <hr />
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <div>
                <select
                  v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                  :disabled="form_submitted"
                >
                  <option value selected="selected">-- {{ label_select }} --</option>
                  <option
                    v-for="(value, index) in countries "
                    :value="value"
                    :key="value"
                  >{{ value }}</option>
                  <option value="other_select">-- {{ label_other }} --</option>
                </select>
                <p
                  class="error"
                  v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
                >{{ label_required }}</p>
              </div>
              <div v-if="otherSelected(form_field['form_field_id'])">
                <input
                  type="text"
                  :disabled="form_submitted"
                  v-model.trim.lazy="$v.form_values['others'][form_field['form_field_id']].$model"
                />
                <p
                  class="error"
                  v-if="form_field['required'] == 1 && $v.form_values['others'][form_field['form_field_id']].$dirty && !$v.form_values['others'][form_field['form_field_id']].required"
                >{{ label_required }}</p>
              </div>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == US_STATES">
              <hr />
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <div>
                <select
                  v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                  :disabled="form_submitted"
                >
                  <option value selected="selected">-- {{ label_select }} --</option>
                  <option
                    v-for="(value, index) in us_states_arr "
                    :value="value"
                    :key="value"
                  >{{ value }}</option>
                </select>
                <p
                  class="error"
                  v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
                >{{ label_required }}</p>
              </div>
              <div v-if="otherSelected(form_field['form_field_id'])">
                <input
                  type="text"
                  :disabled="form_submitted"
                  v-model.trim.lazy="$v.form_values['others'][form_field['form_field_id']].$model"
                />
                <p
                  class="error"
                  v-if="form_field['required'] == 1 && $v.form_values['others'][form_field['form_field_id']].$dirty && !$v.form_values['others'][form_field['form_field_id']].required"
                >{{ label_required }}</p>
              </div>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_RADIO_GROUP">
              <hr />
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <br />
              <div
                v-for="(value, index) in JSON.parse(form_field['value'])"
                :key="index"
                class="checkbox"
              >
                <input
                  :value="value"
                  :id="index+'_'+form_field['form_field_id']"
                  type="checkbox"
                  v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                  :disabled="form_submitted"
                />

                <label :for="index+'_'+form_field['form_field_id']">{{ value }}</label>
              </div>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_DATE">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <div class="date_wrapper">
                <datepicker
                  v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                  :disabled="form_submitted"
                  :format="datepicker_format"
                  :language="getDatepickerLanguage"
                  :use-utc="true"
                  :clear-button="form_field['required'] == 1 ? false : true"
                  :format-typed-date="formatTypedValue"
                ></datepicker>
                <img src="/cdn/images/site/calendar-white-circle.svg" />
              </div>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == INPUT_FILE">
              <label>
              <template v-if="form_field['label'] == 'File 1 (Image files only - png, jpeg, gif, jpg)'"> Receipt / Proof of Purchase (Image files only - png, jpeg, gif, jpg) </template>
              <template v-if="form_field['label'] == 'File 2 (Image files only - png, jpeg, gif, jpg)'"> Image of Issue – 1 (Image files only - png, jpeg, gif, jpg) </template>
              <template v-if="form_field['label'] == 'File 3 (Image files only - png, jpeg, gif, jpg)'"> Image of Issue – 2 (Image files only - png, jpeg, gif, jpg) </template>
              <template v-if="form_field['label'] == 'File 4 (Image files only - png, jpeg, gif, jpg)'"> Image of Issue – 3 (Image files only - png, jpeg, gif, jpg) </template>
              <template v-if="form_field['label'] == 'Upload product receipt'"> Upload proof of purchase </template>
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>

              <input
                type="file"
                :id="form_field['form_field_id']"
                :ref="form_field['form_field_id']"
                :disabled="form_submitted"
                v-on:change="uploadFile(form_field['form_field_id'])"
                accept="image/png, image/jpeg, image/gif, image/jpg, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"
              />
              <div v-if="form_field['label'] == 'Upload product receipt'" style="margin-top: -10px">
              <span >Supported file types: Image files only - png, jpeg, gif, jpg <br></span>
              <span>Max size: 20Mb</span>
              </div>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>

              <p
                class="error"
                v-if="file_invalid_format_errors[form_field['form_field_id']]"
              >{{ label_invalid_filetype }}</p>

              <p
                class="error"
                v-if="file_size_errors[form_field['form_field_id']]"
              >{{ file_size_errors[form_field['form_field_id']] }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == HEADING">
              <h2 class="form-wizard-heading" v-html="form_field['label']">
              </h2>
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
            </div>

            <div v-if="form_field['fieldId'] == CUSTOMER_ADDRESS">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <input
                type="text"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                v-model = customer_address
                :disabled="form_submitted"
                
              />
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <div v-if="form_field['fieldId'] == CUSTOMER_POSTCODE">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <input
              
                type="text"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                v-model = customer_postcode
                :disabled="form_submitted"
                @change = forceRerender
              />
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == POSTCODE_SEARCH">
              <postcodeSearch
              v-if="renderComponent"
              v-on:searchDealer="searchDealer($event)"
              :form_field_id="form_field['form_field_id']"
              :customer_postcode = customer_postcode
              :customer_address = customer_address
              ></postcodeSearch>
            </div>

            <div v-if="form_field['fieldId'] == LOCAL_DEALER_ADDRESS" style="display:none">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <input
                type="text"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                :disabled="form_submitted"
              />
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <div v-if="form_field['fieldId'] == LOCAL_DEALER_CONTACT_NUMBER" style="display:none">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <input
                type="text"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                :disabled="form_submitted"
              />
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <div v-if="form_field['fieldId'] == LOCAL_DEALER_POSTCODE" style="display:none">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <input
                type="text"
                v-model.trim.lazy="$v.form_values[form_field['form_field_id']].$model"
                :disabled="form_submitted"
              />
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>


            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == VEHICLE_WIZARD">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>

              <VehicleDropDown
                v-on:selectVehicleForm="selectVehicleForm($event)"
                :label_manufacturer="label_manufacturer"
                :label_model="label_model"
                :label_year="label_year"
                :label_body_type="label_body_type"
                :label_loading="label_loading"
                :label_select="label_select"
                :label_select_vehicle="label_select_vehicle"
                :form_field_id="form_field['form_field_id']"
                :form_submitted="form_submitted"
              ></VehicleDropDown>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == PART_NUMBER_SELECTOR">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
              </label>
              <product-search
                @product-search-selected="productsearchSelected($event)"
                :form_field_id="form_field['form_field_id']"
                :form_submitted="form_submitted"
              ></product-search>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

            <!-- form field -->
            <!-- form field -->
            <div v-if="form_field['fieldId'] == PART_NUMBER_SELECTOR_MULTIPLE">
              <label>
                {{ form_field['label'] }}
                <span v-if="debug">- {{ form_field['form_field_id'] }} - {{ form_field['fieldId'] }}</span>
                <span v-if="form_field['required'] == 1" class="error">*</span>
                <span style="cursor: pointer; font-weight: 700; color: #005cb9; position: absolute; right: 0px;" v-on:click="addNewInputText(form_field['form_field_id'])">Add new {{ form_field['label'].toLowerCase() }}</span>
              </label>
                <product-search-multiple
                v-for="(input_text_multiple_index, pos) in input_text_multiple_indexes[form_field['form_field_id']]" :key="pos"
                @product-search-selected="productsearchSelectedMutiple($event, form_field['form_field_id'], input_text_multiple_index)"
                :form_field_id="form_field['form_field_id']"
                :form_submitted="form_submitted"
                ></product-search-multiple>
              <p
                class="error"
                v-if="form_field['required'] == 1 && $v.form_values[form_field['form_field_id']].$dirty && !$v.form_values[form_field['form_field_id']].required"
              >{{ label_required }}</p>
            </div>

          </div>
          <p v-if="!form_submitted  && Form['title'] != 'Warranty Registration'">
            <br />
          </p>

          <div>
            <vue-recaptcha
              ref="recaptcha"
              sitekey="6LdWQtwUAAAAAKNZMGCJABPG3JzVsTmsobH_kCOR"
              :loadRecaptchaScript="true"
              @error="error"
              @expired="expired"
              @verify="verify"
              v-if="!form_submitted"
            ></vue-recaptcha>
          </div>

          <p v-if="!form_submitted">
            <br />
          </p>

          <button
            class="btn btn-hover btn-primary submit-form"
            :disabled="form_submitting"
            @click.prevent="submit()"
          >{{ submitText }}</button>

          <button
            v-if="!form_submitted && Form['title'] != 'Warranty Registration'"
            class="btn btn-hover btn-primary submit-form"
            type="reset"
          >{{ label_reset }}</button>

          <p class="error" v-if="$v.$invalid && $v.$dirty">{{ label_error_message}}</p>

          <div v-if="form_submitted" v-html="this.Form['submitted_text'] "></div>
        </div>
      </div>
      <p>
        <br />
      </p>
      <p>
        <br />
      </p>
    </form>
  </div>
</template>
<script>
import { nextTick, ref } from 'vue';
import {
  required,
  email,
  helpers,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import Datepicker from "vuejs-datepicker";
import { en, es, de, fr } from "vuejs-datepicker/dist/locale";
import FormData from "form-data";
import VehicleDropDown from "./form-wizard-vehicle.vue";
import postcodeSearch from "./postcode-search.vue";
import ProductSearch from "./product/standard-dropdown-list.vue";
import ProductSearchMultiple from "./product/standard-dropdown-list-multiple.vue";

const canBeEmpty = (value) => !helpers.req(value) || value != "";

// const file_extension_validation = (value, vm) => {
//   let filename = value;
//   var ext = /^.+\.([^.]+)$/.exec(filename);
//   let fileext = ext == null ? "" : ext[1];
//   let allowedExtensions = ['png','jpeg','gif','jpg','doc','docx','pdf'];
//   return  allowedExtensions.includes(fileext);
// };

export default {
  components: {
    Datepicker,
    VehicleDropDown,
    "product-search": ProductSearch,
    "product-search-multiple": ProductSearchMultiple,
    "postcodeSearch": postcodeSearch,
  },
  validations() {
    return {
      form_values: this.rules,
    };
  },
  props: {
    form: {
      type: String,
      required: true,
    },
    label_invalid: {
      type: String,
      default: "Invalid",
    },
    label_required: {
      type: String,
      default: "Required",
    },
    label_text_too_long: {
      type: String,
      default: "Input text too long (Limit 3000 characters)",
    },
    label_invalid_filetype: {
      type: String,
      default: "Invalid file type ('png','jpeg','gif','jpg','doc','docx','pdf') only",
    },
    label_form_submitted: {
      type: String,
      default: "Form Submitted",
    },
    label_select: {
      type: String,
      default: "select",
    },
    label_reset: {
      type: String,
      default: "reset",
    },
    label_other: {
      type: String,
      default: "other",
    },
    datepicker_format: {
      type: String,
      default: "dd/MM/yyyy",
    },
    datepicker_language: {
      type: String,
      default: "en",
    },
    // Vehicle lng props
    label_manufacturer: {
      type: String,
      default: "Manufacturer",
    },
    label_model: {
      type: String,
      default: "Model",
    },
    label_year: {
      type: String,
      default: "Year",
    },
    label_body_type: {
      type: String,
      default: "Body Type",
    },
    label_loading: {
      type: String,
      default: "Loading",
    },
    label_select_vehicle: {
      type: String,
      default: "Select Vehicle",
    },
    label_error_message: {
      type: String,
      default: "Please complete all required fields marked with a *",
    },
  },
  mounted() {
    this.initFormValues();
  },
  updated() {},
  data() {
    return {
      debug: false,
      token: "",
      verified: false,
      form_submitting: false,
      form_submitted: false,
      form_values: { others: {} },
      validation_errors: {},
      file_size_errors: [],
      selected: [],
      file_invalid_format_errors: [],
      input_text_multiple_indexes : {},
      input_text_multiple_items : {},
      INPUT_TEXT: 1,
      INPUT_EMAIL: 2,
      INPUT_TEXTAREA: 3,
      INPUT_SELECT: 4,
      INPUT_RADIO_GROUP: 5,
      INPUT_DATE: 6,
      INPUT_FILE: 7,
      HEADING: 8,
      VEHICLE_WIZARD: 9,
      PART_NUMBER_SELECTOR: 10,
      COUNTRY_WIZARD: 11,
      INPUT_TEXT_MULTIPLE: 12,
      PART_NUMBER_SELECTOR_MULTIPLE: 13,
      US_STATES: 14,
      POSTCODE_SEARCH: 15,
      CUSTOMER_ADDRESS: 16,
      CUSTOMER_POSTCODE: 17,
      LOCAL_DEALER_ADDRESS: 18,
      LOCAL_DEALER_POSTCODE: 19,
      LOCAL_DEALER_CONTACT_NUMBER: 20,
      PHONE_NUMBER: 23,
      customer_address: null,
      customer_postcode: "",
      name_form_field_id: "",
      local_dealer_address: "",
      local_dealer_postcode: "",
      local_dealer_contact_number: "",
      renderComponent: true,
      us_states_arr : ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','Washington DC','West Virginia','Wisconsin','Wyoming'],
      countries : ['Afghanistan','Albania','Algeria','Andorra','Angola','Antigua and Barbuda','Argentina','Armenia','Australia','Austria','Azerbaijan','Bahamas','Bahrain','Bangladesh','Barbados','Belarus','Belgium','Belize','Benin','Bhutan','Bolivia','Bosnia and Herzegovina','Botswana','Brazil','Brunei','Bulgaria','Burkina Faso','Burundi','Côte d`Ivoire','Cabo Verde','Cambodia','Cameroon','Canada','Central African Republic','Chad','Chile','China','Colombia','Comoros','Congo (Congo-Brazzaville)','Costa Rica','Croatia','Cuba','Cyprus','Czechia (Czech Republic)','Democratic Republic of the Congo','Denmark','Djibouti','Dominica','Dominican Republic','Ecuador','Egypt','El Salvador','Equatorial Guinea','Eritrea','Estonia','Eswatini (fmr. "Swaziland")','Ethiopia','Fiji','Finland','France','Gabon','Gambia','Georgia','Germany','Ghana','Greece','Grenada','Guatemala','Guinea','Guinea-Bissau','Guyana','Haiti','Holy See','Honduras','Hungary','Iceland','India','Indonesia','Iran','Iraq','Ireland','Israel','Italy','Jamaica','Japan','Jordan','Kazakhstan','Kenya','Kiribati','Kuwait','Kyrgyzstan','Laos','Latvia','Lebanon','Lesotho','Liberia','Libya','Liechtenstein','Lithuania','Luxembourg','Madagascar','Malawi','Malaysia','Maldives','Mali','Malta','Marshall Islands','Mauritania','Mauritius','Mexico','Micronesia','Moldova','Monaco','Mongolia','Montenegro','Morocco','Mozambique','Myanmar (formerly Burma)','Namibia','Nauru','Nepal','Netherlands','New Zealand','Nicaragua','Niger','Nigeria','North Korea','North Macedonia','Norway','Oman','Pakistan','Palau','Palestine State','Panama','Papua New Guinea','Paraguay','Peru','Philippines','Poland','Portugal','Qatar','Romania','Russia','Rwanda','Saint Kitts and Nevis','Saint Lucia','Saint Vincent and the Grenadines','Samoa','San Marino','Sao Tome and Principe','Saudi Arabia','Senegal','Serbia','Seychelles','Sierra Leone','Singapore','Slovakia','Slovenia','Solomon Islands','Somalia','South Africa','South Korea','South Sudan','Spain','Sri Lanka','Sudan','Suriname','Sweden','Switzerland','Syria','Tajikistan','Tanzania','Thailand','Timor-Leste','Togo','Tonga','Trinidad and Tobago','Tunisia','Turkey','Turkmenistan','Tuvalu','Uganda','Ukraine','United Arab Emirates','United Kingdom','United States of America','Uruguay','Uzbekistan','Vanuatu','Venezuela','Vietnam','Yemen','Zambia','Zimbabwe']
    };
  },
  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    selectVehicleForm(data) {
      // here goes the data from vehicle dropdown select
      this.form_values[data.data.form_field_id] = data.data.value;
    },
    searchDealer(data) {
        this.form_values[data.data.form_field_id] = data.data.name;
        this.form_values[this.local_dealer_address] = data.data.address;
        this.form_values[this.local_dealer_postcode] = data.data.postcode;
        this.form_values[this.local_dealer_contact_number] = data.data.number;
    },
    addNewInputText(form_field_id){
      this.input_text_multiple_indexes[form_field_id].push(this.input_text_multiple_indexes[form_field_id][this.input_text_multiple_indexes[form_field_id].length - 1] + 1);
      this.$forceUpdate();
    },
    productsearchSelected(data) {
      this.form_values[data.data.form_field_id] = data.data.value;
    },
    productsearchSelectedMutiple(data, form_field_id, index) {
      if(data && data.data && data.data.value && data.data.value != '')
      this.input_text_multiple_items[form_field_id][index] = data.data.value;
    },
    uploadFile(form_field_id) {
      this.$v.form_values[form_field_id].$touch();
      this.file_size_errors = [];

      let allowedExtensions = ['image/png','image/jpeg','image/gif','image/jpg','application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      let filetype = $("#" + form_field_id).prop("files")[0]["type"];

      if(  !allowedExtensions.includes(filetype) ){
        this.file_invalid_format_errors[form_field_id] = 1;
        $("#" + form_field_id).val(null);
      }
      else if ($("#" + form_field_id).prop("files")[0]["size"] > 20971520) {
        this.file_size_errors[form_field_id] = "20Mb file size limit";
        $("#" + form_field_id).val(null);

      } else {
        this.form_values[form_field_id] = $("#" + form_field_id).val()
          ? $("#" + form_field_id).val()
          : [];
      }
    },
    GetFormData() {
      let vm = this;
      const formData = new FormData();

      for (const key in this.form_values) {
        let formField = vm.formFields.find((obj) => {
          return obj.form_field_id === key;
        });

        let fieldId = formField != undefined ? formField.fieldId : "";

        switch (fieldId) {
          case vm.INPUT_FILE:
              if($("#" + key).prop("files") != null && $("#" + key).prop("files") != []){
                 formData.append(key, $("#" + key).prop("files")[0]); 
              }
            
            break;
          default:
            formData.append(key, vm.form_values[key]);
        }
      }

      formData.append("others", JSON.stringify(vm.form_values["others"]));

      return formData;
    },
    formatTypedValue(date) {
      return moment(date, "L").format("YYYY-MM-DD");
    },
    otherSelected(form_field_id) {
      return this.form_values[form_field_id] == "other_select";
    },
    modelPath(form_field) {
      return "$v.form_values[" + form_field["form_field_id"] + "].$model";
    },
    expired(value) {
      this.verified = false;
      this.form_values["token"] = "";
      this.$refs.recaptcha.reset();
    },
    verify(value) {
      this.verified = true;
      this.form_values["token"] = value;
    },
    error(value) {
      this.verified = false;
      this.form_values["token"] = "";
      this.$refs.recaptcha.reset();
    },
    async submit() {
      for(var key in this.input_text_multiple_items){
        this.form_values[key] = (Object.keys(this.input_text_multiple_items[key]).length !== 0) ? JSON.stringify(this.input_text_multiple_items[key]) : null;
      }
      this.$v.form_values.$touch();

      if (this.$v.form_values.$pending || this.$v.form_values.$error) {
        return;
      }

      this.validation_errors = {};

      if (this.verified === true) {
        // alert("all good. lets post");

        this.form_submitting = true;
        // // to form submit after this
        let headers = { headers: { "Content-Type": "multipart/form-data;" } };

        // let vals = { form_values: this.form_values};
        let response = await axios.post(`api/formWizard`, this.GetFormData(), {
          headers: {
            "content-type": "multipart/form-data", // do not forget this
          },
        });

        if (
          response.data.data === this.form_values["token"] &&
          response.data.success === true
        ) {
          this.form_submitted = true;
          this.form_submitting = false;
        } else if (response.data.success === false && response.data.message) {
          this.$set(this.validation_errors, response.data.message, true);
          this.$refs.recaptcha.reset();
          this.form_submitted = false;
          this.form_submitting = false;
        } else {
          this.form_submitted = false;
          this.form_submitting = false;
        }
      }
    },
    initFormValues() {

      let fm = this.form_values;
      let fm_others = this.form_values["others"];
      let vm = this;

      this.$set(fm, "formId", this.Form["formId"]);
      this.$set(fm, "groupId", this.Form["groupId"]);

      this.formFields.forEach(function (form_field, index) {
        let form_field_id = form_field["form_field_id"];

        switch (form_field.fieldId) {
          case vm.HEADING:
            vm.$set(fm, form_field_id, form_field["label"]);
            break;
          case vm.INPUT_DATE:
            let date = "";
            vm.$set(fm, form_field_id, date);
            break;
          case vm.INPUT_TEXT_MULTIPLE :
          case vm.PART_NUMBER_SELECTOR_MULTIPLE :
              vm.input_text_multiple_indexes[form_field_id] = [0];
              vm.input_text_multiple_items[form_field_id] = {};
              vm.$set(fm, form_field_id, []);
            break;
          default:
            vm.$set(fm, form_field_id, []);
        }

        vm.$set(fm_others, form_field_id, []);
      });
    },
    
  },
  computed: {

    getDatepickerLanguage() {
      switch (this.datepicker_language) {
        case "es":
          return es;
          break;
        case "fr":
          return fr;
          break;
        case "de":
          return de;
          break;
        default:
          return en;
      }
    },
    Form() {
      return JSON.parse(this.form);
    },
    submitText() {
      return this.Form["submit_text"] ? this.Form["submit_text"] : "Submit";
    },
    formFields() {
      return this.Form["form_fields"] ? this.Form["form_fields"] : [];
    },
    rules() {
      let formrules = { others: {} };

      let rule_blank = { canBeEmpty };
      let rule_required = { required };
      let rule_email = { email };
      let rule_required_email = { required, email };
      let rule_max_len = { maxLength: maxLength(3000) };
      let rule_required_max_len = { required, maxLength: maxLength(3000) };
    //   let rule_mime_types = { file_extension_validation };
    //   let rule_required_mime_types = { required, file_extension_validation };

      this.formFields.forEach((form_field, index) => {

        let form_field_id = form_field["form_field_id"];

        formrules[form_field_id] = rule_blank;
        formrules["others"][form_field_id] = rule_blank;

        if (form_field.required == 1) {
          formrules[form_field_id] = rule_required;

          if (this.form_values[form_field_id] == "other_select") {
            formrules["others"][form_field_id] = rule_required;
          }
        }

        if (form_field.fieldId == this.HEADING) {
          formrules[form_field_id] = rule_blank;
        }

        if (form_field.fieldId == this.LOCAL_DEALER_ADDRESS) {
           this.local_dealer_address = form_field['form_field_id'];
          formrules[form_field_id] = rule_blank;
        }

        if (form_field.fieldId == this.LOCAL_DEALER_CONTACT_NUMBER) {
          this.local_dealer_contact_number = form_field['form_field_id'];
          formrules[form_field_id] =  {
              minLength: minLength(7),
              ...rule_blank
            };
        }

        if (form_field.fieldId == this.LOCAL_DEALER_POSTCODE) {
          this.local_dealer_postcode = form_field['form_field_id'];
          formrules[form_field_id] = rule_blank;
        }

        if (form_field.fieldId == this.INPUT_EMAIL) {
          formrules[form_field_id] = rule_email;
        }

        if (
          form_field.fieldId == this.INPUT_EMAIL &&
          form_field.required == 1
        ) {
          formrules[form_field_id] = rule_required_email;
        }

        if (form_field.fieldId == this.INPUT_TEXTAREA) {
          formrules[form_field_id] = rule_max_len;
        }

        if (
          form_field.fieldId == this.INPUT_TEXTAREA &&
          form_field.required == 1
        ) {
          formrules[form_field_id] = rule_required_max_len;
        }

        if (form_field.fieldId == this.PHONE_NUMBER) {
            formrules[form_field_id] = {
              minLength: minLength(7),
              ...rule_blank
            };
          }

        // if (form_field.fieldId == this.INPUT_FILE) {
        //   formrules[form_field_id] = rule_mime_types;
        // }

        // if (form_field.fieldId == this.INPUT_FILE && form_field.required == 1) {
        //   formrules[form_field_id] = rule_required_mime_types;
        // }
      });

      return formrules;
    },
  },
directives: {
  'numeric-plus-only': {
    bind(el) {
      el.addEventListener('input', function() {
        let value = el.value;
        value = value.replace(/[^0-9+\-\s]/g, '');

        // const val = value;
        // let valueWithoutSpaces = val.replace(/\s+/g, '');
        // let numChars = valueWithoutSpaces.length;

        // if (numChars > 10) {
        //   let charactersExceeded = numChars - 10;
        //   value = value.slice(0, value.length - charactersExceeded);
        // }

        el.value = value;

      });
    }
  }
}

};
</script>
